"use client";

import { UserButton } from "@clerk/nextjs";

export function UserButtonWithMenu() {
  return (
    <UserButton
      appearance={{
        elements: {
          avatarBox: "w-9 h-9",
          userButtonPopoverCard:
            "bg-[#1c1914] border border-[rgba(250,246,238,0.1)] shadow-xl",
          userButtonPopoverActionButton:
            "text-[rgba(250,246,238,0.75)] hover:bg-[rgba(250,246,238,0.06)] hover:text-[#faf6ee]",
          userButtonPopoverActionButtonText: "text-[rgba(250,246,238,0.75)]",
          userButtonPopoverActionButtonIcon: "text-[#c9a84c]",
          userButtonPopoverFooter: "hidden",
          userButtonPopoverActionButtonIcon__manageAccount: "text-[#c9a84c]",
          userButtonPopoverFooterPages: "hidden",
          userPreviewMainIdentifier: "text-[#faf6ee]",
          userPreviewSecondaryIdentifier: "text-[rgba(250,246,238,0.55)]",
        },
        variables: {
          colorBackground: "#1c1914",
          colorText: "#faf6ee",
          colorTextSecondary: "rgba(250,246,238,0.55)",
          colorInputBackground: "#21201c",
          colorInputText: "#faf6ee",
          colorPrimary: "#c9a84c",
          colorShimmer: "#21201c",
          colorNeutral: "#faf6ee",
        },
      }}
    />
  );
}
